    <div class="base_analytics_section-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54"
            viewBox="0 0 54 54" fill="none">
            <rect width="54" height="54" rx="27" fill="#D7F3FF" />
            <path
                d="M42.9124 31.7433L41.6849 27.1225C41.131 25.0766 39.6153 23.5003 37.7023 22.8149C36.4866 23.6451 35.0301 24.1266 33.454 24.1266C31.8778 24.1266 30.4094 23.6451 29.1939 22.8149C27.2808 23.5004 25.7637 25.0779 25.2231 27.1225L25.0547 27.7606H28.0874C29.0018 27.7606 29.8438 28.1698 30.4096 28.8921C30.9754 29.6144 31.1793 30.5407 30.9517 31.4314L30.1096 34.8616H40.5194C42.1562 34.8616 43.3351 33.3209 42.914 31.7447L42.9124 31.7433Z"
                fill="#1AACD9" />
            <path
                d="M38.9925 16.5404C38.9925 19.5994 36.5124 22.0794 33.4535 22.0794C30.3931 22.0794 27.9131 19.5993 27.9131 16.5404C27.9131 13.48 30.3932 11 33.4535 11C36.5125 11 38.9925 13.4801 38.9925 16.5404Z"
                fill="#1AACD9" />
            <path
                d="M20.2296 41.2114C20.2296 43.356 17.0127 43.356 17.0127 41.2114C17.0127 39.0654 20.2296 39.0654 20.2296 41.2114Z"
                fill="#1AACD9" />
            <path
                d="M24.6208 39.6023C23.7327 39.6023 23.0117 40.322 23.0117 41.2114C23.0117 42.0995 23.7327 42.8205 24.6208 42.8205C25.5089 42.8205 26.2299 42.1008 26.2299 41.2114C26.2299 40.3233 25.5102 39.6023 24.6208 39.6023Z"
                fill="#1AACD9" />
            <path
                d="M28.0859 29.8069H16.1234L15.5918 27.4491C15.4984 27.0334 15.13 26.74 14.7037 26.74L11.9105 26.7386C11.4079 26.7386 11 27.1465 11 27.6491C11 28.1517 11.4079 28.5582 11.9105 28.5582H13.9761L15.8128 36.7012C16.0733 37.8604 17.0864 38.6695 18.2745 38.6695H25.0884C26.2528 38.6695 27.2606 37.8801 27.5383 36.7499L28.9697 30.9344C29.0368 30.6633 28.975 30.3752 28.8027 30.1555C28.6303 29.9358 28.3661 29.8069 28.0859 29.8069Z"
                fill="#1AACD9" />
        </svg>
        <span i18n="@@storefront_analytics.top_ordering_customers">Top ordering customers</span>
    </div>
    <div class="base_analytics_section-body">
        <div class="d-flex flex-column w-100">
            <!-- Loop through analyticsData array -->
            <div
                class="analytics_card"
                *ngFor="let item of analyticsData">
                <div class="d-flex flex-column w-100 gap-2">
                    <span class="name fs-4 fw-bold">{{ item.name }}</span>
                    <div class="d-flex align-items-center justify-content-between flex-wrap">
                        <span class="orders_total">
                            <strong>{{ item.ordersTotal }}</strong> <span  i18n="@@storefront_analytics.orders_total">orders total</span>
                        </span>
                        <span class="orders_total revenue">
                            <!-- <strong>{{ item.revenue }}</strong> revenue -->
                            <span class="currency-img" [innerHTML]="item?.currency_symbol"></span>
                            <strong>
                                {{item.amount}}
                            </strong> <span  i18n="@@storefront_analytics.revenue">revenue</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <a href="/clients" class="primary_btn">See all</a>
